/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Stats_BillingInputs */

const en_home_stats_billing = /** @type {(inputs: Home_Stats_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Direct Billing`)
};

const fr_home_stats_billing = /** @type {(inputs: Home_Stats_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facturation directe`)
};

/**
* | output |
* | --- |
* | "Direct Billing" |
*
* @param {Home_Stats_BillingInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_stats_billing = /** @type {((inputs?: Home_Stats_BillingInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Stats_BillingInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_stats_billing(inputs)
	return fr_home_stats_billing(inputs)
});